import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Instagram } from "lucide-react";

const IG_PROFILE = "https://www.instagram.com/legendmagazine.it/";

export default function InstagramFeed() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    client.get("/instagram/recent").then((r) => {
      if (r.data?.items?.length) setItems(r.data.items);
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="instagram-feed" className="max-w-7xl mx-auto px-4 py-10">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-sm bg-gradient-to-tr from-[#feda75] via-[#d62976] to-[#4f5bd5] text-white">
            <Instagram size={22} />
          </span>
          <div>
            <h2 className="font-display font-black uppercase text-2xl leading-none">Instagram</h2>
            <a href={IG_PROFILE} target="_blank" rel="noreferrer" className="text-sm text-legend-red font-mono hover:underline">@legendmagazine.it</a>
          </div>
        </div>
        <a href={IG_PROFILE} target="_blank" rel="noreferrer" data-testid="ig-follow-btn" className="hidden sm:inline-flex items-center gap-2 bg-legend-ink text-white text-sm font-bold uppercase px-4 py-2 rounded-sm hover:bg-slate-800">
          <Instagram size={15} /> Seguici
        </a>
      </div>

      {items.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="ig-grid">
          {items.map((m) => (
            <a key={m.id} href={m.permalink} target="_blank" rel="noreferrer" data-testid="ig-post" className="group relative aspect-square rounded-sm overflow-hidden bg-legend-ink">
              <img src={m.image} alt={m.caption} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors grid place-items-center">
                <Instagram size={26} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </a>
          ))}
        </div>
      ) : (
        <a href={IG_PROFILE} target="_blank" rel="noreferrer" data-testid="ig-cta" className="block rounded-sm border-2 border-dashed border-slate-300 dark:border-slate-700 p-8 text-center hover:border-legend-red transition-colors">
          <Instagram size={34} className="mx-auto text-legend-red mb-2" />
          <p className="font-display font-bold uppercase text-lg">Seguici su Instagram</p>
          <p className="text-sm text-slate-500">Foto, dirette e dietro le quinte dal mondo del motorsport: @legendmagazine.it</p>
        </a>
      )}
    </section>
  );
}
